query DocumentsListQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: DocumentsFilterInput
) {
  documents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      slug
      type
      isPublished
      version
      platform {
        id
        title
      }
      language {
        id
        title
      }
      createdAt
      deletedAt
      deleted
    }
  }
}
